
import React, { useEffect, useState } from "react";
import {
    Typography,
    Radio,
    Box,
    Paper,
    IconButton
  } from "@mui/material";
  import {
    Delete as DeleteIcon,
    Edit as EditIcon
  } from "@mui/icons-material";


const SavedCardItem = ({ card, isSelected, onSelect, setPaymentMethod, onDelete, onSetDefault }) => {
    const handleSelect = (e) => {
      e.preventDefault();
      e.stopPropagation();
      setPaymentMethod("card");
      onSelect(card);
    };
  
    const handleDelete = (e) => {
      e.preventDefault();
      e.stopPropagation();
      onDelete(card.id);
    };
  
    const handleSetDefault = (e) => {
      e.preventDefault();
      e.stopPropagation();
      onSetDefault(card.id);
    };
    const cardNumber = card?.last_four || '';
    const cardholderName = card.meta?.delta_q9 || '';
    const isDefault = card?.is_default || false;
  
    return (
      <Paper 
        elevation={2} 
        sx={{
          p: 2,
          mb: 1,
          border: isSelected ? '2px solid #C41E3A' : '1px solid #ddd',
          borderRadius: '8px',
          cursor: 'pointer',
          backgroundColor: isSelected ? '#fff5f5' : '#fff',
          transition: 'all 0.2s',
          '&:hover': {
            backgroundColor: '#f9f9f9',
          }
        }}
        onClick={handleSelect}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box>
            <Typography variant="body1" fontWeight="bold">{cardholderName}</Typography>
            <Typography variant="body2">**** **** **** {cardNumber}</Typography>
          </Box>
          <Box>
          <IconButton 
              size="small" 
              color="primary" 
              onClick={handleSetDefault}
              sx={{ ml: 1 }}
              aria-label="Set as default card"
              disabled={isDefault}
            >
              <EditIcon fontSize="small" />
            </IconButton>
            <IconButton 
              size="small" 
              color="error" 
              onClick={handleDelete}
              sx={{ ml: 0 }}
              aria-label="Delete card"
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
            <Radio 
              checked={isSelected} 
              onClick={handleSelect}
              onChange={handleSelect}
          />
          </Box>
        </Box>
      </Paper>
      
    );
  };


export default SavedCardItem;